
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    const exchangeRate = 1.95583; // Фиксиран курс BGN към EUR
    const currencySymbol = "€";

    const priceElements = document.querySelectorAll(
      '.price, .product__price, .price-item--regular, .price-item--sale, [data-product-price]'
    );

    priceElements.forEach(function (el) {
      if (!el || !el.innerText) return;

      const priceText = el.innerText.replace(/[^\d.,]/g, "").replace(",", ".");
      const priceValue = parseFloat(priceText);

      if (isNaN(priceValue)) return;

      const euroValue = (priceValue / exchangeRate).toFixed(2);
      const euroElement = document.createElement("div");
      euroElement.style.fontSize = "1.1em"; // по-голям шрифт
      euroElement.style.color = "green";   // зелен цвят
      euroElement.style.marginTop = "4px";
      euroElement.style.display = "block";
      euroElement.style.fontWeight = "bold";
      euroElement.innerText = `${currencySymbol}${euroValue} EUR (Евро)`;

      el.parentNode.insertBefore(euroElement, el.nextSibling);
    });
  }, 1000); // Изчакване 1 секунда, за да се заредят цените
});
